module.exports = __webpack_public_path__ + "static/WEDDING E&M-508-07724302481d5cc91ac1d1b99cadc53a.jpg";